export default {
  categoryComment: {
    accountCategory: {
      displayText: 'Referente',
      value: 'GENERAL'
    },
    chargeCategory: {
      displayText: 'Cargo'
    }
  },
  resolveText: 'Resuelto',
  tabsText: {
    preAudit: 'Pre auditoria',
    concurrent: 'Concurrente'
  },
  managementComments: {
    textDisplayButtonAddComment: 'Comentario General',
    addCommentAccount: 'Agregar comentario a cuenta',
    addCommentCharge: 'Agregar comentario a cargo',
    editComment: 'Editar comentario',
    placeHolderValue: 'Añadir Comentario',
    textButtons: {
      accept: 'Aceptar',
      cancel: 'Cancelar',
      delete: 'Eliminar'
    },
    deleteConfirmation: {
      title: 'Eliminar comentario de auditoría',
      message: '¿Estás seguro de que deseas eliminar este comentario? Esta acción no se puede deshacer y quedará registrada en el historial de auditoría.',
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    }
  },
  alertMessages: {
    createdComment: 'El comentario se guardó exitosamente',
    editComment: 'El comentario se editó exitosamente',
    deleteComment: 'El comentario se borró exitosamente',
    errorCommentMissing: 'Por favor ingresa un comentario antes de guardarlo',
    errorDefault: 'Se produjo un error al gestionar el comentario'
  }
}
